export function calcDimensions(parentElement, aspectRatio, region) {
    const bounds = parentElement.getBoundingClientRect();
    const containerAspect = bounds.width / bounds.height;

    const targetWidth = aspectRatio > containerAspect ? bounds.width : bounds.height * aspectRatio;
    const targetHeight = aspectRatio > containerAspect ? bounds.width / aspectRatio : bounds.height;
    let changedScale = 1;

    if (region) {
        const regionRatio = (region.width * targetWidth) / (region.height * targetHeight);
        changedScale = containerAspect > regionRatio ? bounds.height / (targetHeight * region.height) : bounds.width / (targetWidth * region.width);
    }

    return {
        width: targetWidth,
        height: targetHeight,
        scale: changedScale
    }
}